<template>
  <div class="placeOrder">
    <template v-if="controllerNumber.length">
      <ticketInfo
        :selectDate="selectDate"
        :fullTicketInfo="fullTicketInfo"
        :controllerNumber="controllerNumber">
      </ticketInfo>
      <fillContacts
        v-if="
          !(
            screenData.needContactName == 'false' &&
            screenData.needContactMobile == 'false' &&
            screenData.needContactEmail == 'false' &&
            screenData.needContactHKMTPassport == 'false' &&
            screenData.needContactIDCard == 'false' &&
            screenData.needContactPassport == 'false'
          )
        "
        :realName="userInfo.realName"
        :mobile="userInfo.mobile"
        :email="userInfo.email"
        :idCardNo="userInfo.idCardNo"
        @matchContact="matchContact"
        :screenData="screenData">
      </fillContacts>
      <batchButton
        :class="{ 'not-show': !checkNeedUsefulPerson }"
        @clickBatch="clickBatch">
      </batchButton>
      <inputDevice
        :class="{ 'not-show': !checkNeedUsefulPerson }"
        @updataControllerNumber="updataControllerNumber"
        ref="DOMInputDevice"
        :selectDate="selectDate"
        :controllerNumber="controllerNumber">
      </inputDevice>
      <calculationAction
        ref="DOMCalculationAction"
        :nextStepName="screenData.saleType == 'free' ? '立即预约' : '立即支付'"
        @nextStep="nextStep"
        :fullPrice="Number(fullPrice)"
        :controllerNumber="controllerNumber"
      >
      </calculationAction>
    </template>
  </div>
</template>

<script>
import loading from '@/components/common/loading';
import ticketInfo from "@/components/buyTickets/placeOrder/ticketInfo";
import fillContacts from "@/components/buyTickets/placeOrder/fillContacts";
import { getCreateOrder } from "@/service/buyTickets/touristGuide.js";
import inputDevice from "@/components/buyTickets/placeOrder/inputDevice";
import calculationAction from "@/components/buyTickets/shoppingCart/calculationAction";
import batchButton from "@/components/buyTickets/touristGuideShoppingCart/batchButton";

export default {
  name: "touristGuidePlaceOrder",
  data() {
    return {
      controllerNumber: [],
      fullTicketInfo: {},
      fullPrice: 0,
      selectDate: {},
      userInfo: {},
      contactItems: {
        contactName: "",
        contactPhone: "",
        contactEmail: "",
        contactCerType: "id_card",
        contactCerNo: "",
      },
      createdDoading: loading(),
      screenData: {},
      checkNeedUsefulPerson: true,
    }
  },
  created(){
    const keepState = this.initialization();
    if(keepState){
      this.checkNeedUsefulPerson = this.needUsefulPerson();
      this.getUserInfo();
    };
  },
  methods: {
    clickBatch(){
      window.sessionStorage.setItem('controllerNumber', JSON.stringify(this.controllerNumber));
      this.$router.push('/touristBatchImport');
    },
    initialization(){
      const orderinformation = JSON.parse(window.sessionStorage.getItem('orderinformation')) || false;
      if(!orderinformation){
        this.$router.push('/groupticketlist');
        return false;
      };
      const { controllerNumber, selectDate, fullTicketInfo } = orderinformation;
      const _controllerNumber = JSON.parse(window.sessionStorage.getItem('controllerNumber')) || false;
      if(_controllerNumber){
        this.controllerNumber = _controllerNumber;
      }else{
        this.controllerNumber = controllerNumber;
      };
      this.fullTicketInfo = fullTicketInfo;
      this.selectDate = selectDate;
      this.generateScreenData();
      return true;
    },
    generateScreenData(){
      const controllerNumber = this.controllerNumber;
      const checkMergeRule = Boolean(controllerNumber.filter(v => v.count).length > 1);
      if(checkMergeRule){
        const screenData = controllerNumber[0].metaTicketInfo;
        controllerNumber.forEach(({ metaTicketInfo }) => {
          if(metaTicketInfo.needContactEmail === 'true')screenData.needContactEmail = metaTicketInfo.needContactEmail;
          if(metaTicketInfo.needContactHKMTPassport === 'true')screenData.needContactHKMTPassport = metaTicketInfo.needContactHKMTPassport;
          if(metaTicketInfo.needContactIDCard === 'true')screenData.needContactIDCard = metaTicketInfo.needContactIDCard;
          if(metaTicketInfo.needContactMobile === 'true')screenData.needContactMobile = metaTicketInfo.needContactMobile;
          if(metaTicketInfo.needContactName === 'true')screenData.needContactName = metaTicketInfo.needContactName;
          if(metaTicketInfo.needContactPRC === 'true')screenData.needContactPRC = metaTicketInfo.needContactPRC;
          if(metaTicketInfo.needContactPassport === 'true')screenData.needContactPassport = metaTicketInfo.needContactPassport;
        });
        this.screenData = screenData;
      }else{
        this.screenData = controllerNumber.find(v => v.count).metaTicketInfo;
      };
    },
    updataControllerNumber({
      type,
      data,
    }){
      if(type === 'updata'){
        this.controllerNumber.forEach((v, i) => v.orderItemAttr = data[i].orderItemAttr);
      } else if(type === 'delete'){
        this.controllerNumber.forEach((v, i) => v.orderItemAttr = data[i].orderItemAttr);
      };
    },
    generateScreenData(){
      const controllerNumber = this.controllerNumber;
      const checkMergeRule = Boolean(controllerNumber.filter(v => v.count).length > 1);
      if(checkMergeRule){
        const screenData = controllerNumber[0].metaTicketInfo;
        controllerNumber.forEach(({ metaTicketInfo }) => {
          if(metaTicketInfo.needContactEmail === 'true')screenData.needContactEmail = metaTicketInfo.needContactEmail;
          if(metaTicketInfo.needContactHKMTPassport === 'true')screenData.needContactHKMTPassport = metaTicketInfo.needContactHKMTPassport;
          if(metaTicketInfo.needContactIDCard === 'true')screenData.needContactIDCard = metaTicketInfo.needContactIDCard;
          if(metaTicketInfo.needContactMobile === 'true')screenData.needContactMobile = metaTicketInfo.needContactMobile;
          if(metaTicketInfo.needContactName === 'true')screenData.needContactName = metaTicketInfo.needContactName;
          if(metaTicketInfo.needContactPRC === 'true')screenData.needContactPRC = metaTicketInfo.needContactPRC;
          if(metaTicketInfo.needContactPassport === 'true')screenData.needContactPassport = metaTicketInfo.needContactPassport;
        });
        this.screenData = screenData;
      }else{
        this.screenData = controllerNumber.find(v => v.count).metaTicketInfo;
      };
    },
    async nextStep(){
      this.$refs.DOMCalculationAction.changeDetailed(false);
      // 匹配联系人校验规则元门票数据
      const screenData = this.screenData;
      // 校验联系人
      if (screenData.needContactName === "true" && !this.contactItems.contactName)return this.$toast("请输入联系人姓名");
      if (screenData.needContactMobile === "true" && !this.contactItems.contactPhone)return this.$toast("请输入联系人手机号");
      if (screenData.needContactEmail === "true" && !this.contactItems.contactEmail)return this.$toast("请输入联系人邮箱");
      if (!(screenData.needContactIDCard === "false" && screenData.needContactHKMTPassport === "false" && screenData.needContactPassport === "false" && screenData.needContactPRC === "false") && !this.contactItems.contactCerNo)
      return this.$toast("请输入联系人证件号");
      if (screenData.needContactMobile === "true" && !this.$reg.checkPhone(this.contactItems.contactPhone) && !this.$reg.checkLandline(this.contactItems.contactPhone))return this.$toast("联系人电话格式错误");
      if (screenData.needContactEmail === "true" && !this.$reg.checkEmail(this.contactItems.contactEmail))return this.$toast("联系人邮箱号码错误");
      if (screenData.needContactIDCard === "true" && !this.$reg.checkIDCard(this.contactItems.contactCerNo))return this.$toast("联系人证件号错误");
      if(this.checkNeedUsefulPerson){
        // 输入组件自我检查并返回检查结果
        const failText = this.$refs.DOMInputDevice.checkControllerNumber();
        if(failText)return this.$toast(failText);
      }
      const saleDate = this.selectDate;
      const { periodId } = saleDate.datePeriodInfo;
      let parameter = {
        appCode: "tyrtfgd5",
        userId: this.userInfo.userId,
        contactName: this.contactItems.contactName && this.contactItems.contactName.trim(),
        contactPhone: this.contactItems.contactPhone && this.contactItems.contactPhone.trim(),
        contactEmail: this.contactItems.contactEmail && this.contactItems.contactEmail.trim(),
        contactCerType: this.contactItems.contactCerType,
        contactCerNo: this.contactItems.traverllerCerNo && this.contactItems.traverllerCerNo.toUpperCase().trim(),
        payType: "WEIXIN",
        orderItems: []
      };
      this.controllerNumber.forEach(item => {
        const { needCertAsMedia, productId } = item.metaTicketInfo;
        const currentTag = item.metaTicketInfo.attrInfos.find(v => v.friendlyName === 'SALE_TYPE').key === 'full' ? 'adult' : 'student';
        if(!item.orderItemAttr.length)return;
        item.orderItemAttr.forEach(item => {
          if(!item.traverllerCerNo)item.traverllerCerType = '';
          item.traverllerCerNo = item.traverllerCerNo.trim();
          item.traverllerEmail = item.traverllerEmail.trim();
          item.traverllerName = item.traverllerName.trim();
          item.traverllerPhone = item.traverllerPhone.trim();
        });
        // 一个二维码一个人
        if (needCertAsMedia === "true") {
          item.orderItemAttr.forEach((traverller) => {
            const options = {
                ticketId: productId,
                playDate: saleDate.saleDate,
                playPeriodId: periodId,
                attrList: [traverller],
                playCount: 1,
                tag: currentTag,
            };
            options.traverllerName = traverller.traverllerName;
            options.traverllerPhone = traverller.traverllerPhone;
            options.traverllerEmail = traverller.traverllerEmail;
            options.traverllerCerType = traverller.traverllerCerType;
            options.traverllerCerNo = traverller.traverllerCerNo.toUpperCase();
            traverller.traverllerCerNo = traverller.traverllerCerNo.toUpperCase();
            parameter.orderItems.push(options);
          });
        }else{
          // 一个二维码多人
          const options = {
              ticketId: productId,
              playDate: saleDate.saleDate,
              playPeriodId: periodId,
              attrList: item.orderItemAttr,
              playCount: item.orderItemAttr.length,
              tag: currentTag,
          };
          parameter.orderItems.push(options);
        };
      });
      this.upUserInfoData();
      this.upGroupUserInfo();
      const data = await getCreateOrder.call(this, parameter);
      const { orderId } = data.data;
      const callback = {
        orderId,
        orderType: 1,
        orderSource: 'WX',
        returnUrl: encodeURIComponent(`${process.env.VUE_APP_WECHAT_BOUNCE_BACK}#/guideorderdetails?orderId=${orderId}`),
        errorUrl: encodeURIComponent(`${process.env.VUE_APP_WECHAT_BOUNCE_BACK}#/guideorderdetails?orderId=${orderId}`),
      };
      window.sessionStorage.removeItem('orderinformation')
      window.sessionStorage.removeItem('controllerNumber')
      window.sessionStorage.removeItem('oftenContacts')
      this.createdDoading.loadingStata = true;
      location.href = `${process.env.VUE_APP_BASE_URL}/unified/pay?orderId=${callback.orderId}&orderSource=${callback.orderSource}&orderType=${callback.orderType}&returnUrl=${callback.returnUrl}&errorUrl=${callback.errorUrl}`;
      setTimeout(() => {
        this.createdDoading.loadingStata = false;
        this.$beyondHiding(false);
      }, 8000)
    },
    upUserInfoData(){
      const userInfo = this.userInfo;
      userInfo.mobile = this.contactItems.contactPhone;
      if(userInfo.realName){
        userInfo.realName = this.contactItems.contactName;
      }else{
        userInfo.name = this.contactItems.contactName;
      };
      userInfo.email = this.contactItems.contactEmail;
      if(userInfo.idCard && this.$reg.checkIDCard(userInfo.idCard))this.contactItems.contactCerNo = userInfo.idCard;
      window.localStorage.setItem('userInfo', JSON.stringify(userInfo));
    },
    upGroupUserInfo(){
      // let groupUserInfo = window.sessionStorage.getItem('groupUserInfo');
      let groupUserInfo = this.userInfo.extField1
      if(!groupUserInfo)return;
      groupUserInfo = JSON.parse(groupUserInfo);
      groupUserInfo.mobile = this.contactItems.contactPhone;
      groupUserInfo.realName = this.contactItems.contactName;
      groupUserInfo.email = this.contactItems.contactEmail;
      if(groupUserInfo.idCard && this.$reg.checkIDCard(groupUserInfo.idCard))this.contactItems.contactCerNo = groupUserInfo.idCard;
      window.sessionStorage.setItem('groupUserInfo', JSON.stringify(groupUserInfo));
    },
    matchContact(options) {
      switch (options.type) {
        case "needContactName":
          this.contactItems.contactName = options.value;
          this.userInfo.name = options.value;
          break;
        case "needContactMobile":
          this.contactItems.contactPhone = options.value;
          this.userInfo.mobile = options.value;
          break;
        case "needContactEmail":
          this.contactItems.contactEmail = options.value;
          this.userInfo.email = options.value;
          break;
        case "contactCerType":
          this.contactItems.contactCerType = options.value;
          break;
        case "contactCerNo":
          this.contactItems.contactCerNo = options.value;
          this.userInfo.idCard = options.value;
      }
    },
    getUserInfo() {
      this.userInfo = JSON.parse(window.localStorage.getItem("userInfo"));
      this.contactItems.contactPhone = this.userInfo.mobile;
      this.contactItems.contactName = this.userInfo.realName || this.userInfo.name;
      this.contactItems.contactEmail = this.userInfo.email;
      this.contactItems.contactCerNo = this.userInfo.idCard;
    },
    needUsefulPerson(){
      return this.controllerNumber.some(item => {
        if(item.count > 0){
          const { metaTicketInfo } = item;
          if(metaTicketInfo.needTravellerEmail == 'true')return true;
          if(metaTicketInfo.needTravellerHKMTPassport == 'true')return true;
          if(metaTicketInfo.needTravellerIDCard == 'true')return true;
          if(metaTicketInfo.needTravellerMilitarycard == 'true')return true;
          if(metaTicketInfo.needTravellerMobile == 'true')return true;
          if(metaTicketInfo.needTravellerName == 'true')return true;
          if(metaTicketInfo.needTravellerOther == 'true')return true;
          if(metaTicketInfo.needTravellerPRC == 'true')return true;
          if(metaTicketInfo.needTravellerPassport == 'true')return true;
          return false;
        }
      })
    },
  },
  watch: {
    controllerNumber: {
      handler(newValue){
        const fullPrice = newValue.reduce((total, currentValue, currentIndex, arr) => {
          total += Number(currentValue.salePrice) * currentValue.count;
          return total;
        }, 0);
        this.fullPrice = String(fullPrice.toFixed(2)).padStart(2, 0);
      },
      deep: true,
    }
  },
  components: {
    ticketInfo,
    fillContacts,
    inputDevice,
    batchButton,
    calculationAction,
  }
};
</script>
